import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	// Institution basic info
	id: null,
	name: null,
	clientId: null,
	contactEmail: null,
	contactPhone: null,
	emailDomain: null,
	institutionType: null,
	registrationNumber: null,
	regulatoryLicense: null,
	
	// Verification status
	isVerified: false,
	verificationStatus: 'PENDING', // PENDING, APPROVED, REJECTED
	
	// URLs
	callbackUrl: null, // Legacy
	sandboxWebhookUrl: null,
	productionWebhookUrl: null,
	
	// Security
	whitelistedIPs: [],
	
	// Dashboard settings
	dashboardEnvironment: 'test', // test or live
	currentApiKey: null,
	
	// API Keys (from separate keys table)
	keys: {
		test: {
			apiKey: null,
			environment: 'sandbox'
		},
		production: {
			apiKey: null,
			environment: 'production',
			activated: false
		}
	},
	
	// Audit fields
	lastLoginAt: null,
	loginCount: 0,
	
	// Timestamps
	createdAt: null,
	updatedAt: null,
};

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setUserData: (state, action) => {
			return { ...state, ...action.payload };
		},
		updateUserField: (state, action) => {
			const { field, value } = action.payload;
			state[field] = value;
		},
		clearUserData: (state) => {
			return initialState;
		},
	},
});

export const {
	setUserData,
	updateUserField,
	clearUserData,
} = userSlice.actions;

export default userSlice.reducer;
